// extracted by mini-css-extract-plugin
module.exports = {"media-wrapper":"Media_media-wrapper__2RqHZ"};